import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { useDispatch, useStore } from "react-redux";
import {
  IonAlert,
  IonBadge,
  IonButton,
  IonCard,
  IonCheckbox,
  IonContent,
  IonDatetime,
  IonLabel,
  IonLoading,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonProgressBar,
} from "@ionic/react";
import { decode } from "base64-arraybuffer";
import { useForm } from "react-hook-form";
import html2canvas from "html2canvas";

import {
  adjustBorderHeight,
  getQrCodeInfo,
  noInternetResponse,
  showToastMessage
} from "../../common/common";
import { getModelProfileData } from "../../data-services/edit-profile";
import { Network } from "@capacitor/network";
import axios from "axios";



const QR16VitaCocoSuccess: React.FC = () => {
  const history = useHistory();
  const photoContainerRef = useRef<HTMLDivElement>(null);

  const [qrDetails, setQrDetails] = useState<any>();
  const populateQrCodeInfo = () => {
    let qrDetails = getQrCodeInfo();
    setQrDetails(qrDetails);
  }

  useEffect(() => {
    populateQrCodeInfo();
    adjustBorderHeight(670);
  }, []);

  const trackCTAClick = async () => {
    const options: any = {
      method: "post",
      url: `${process.env.REACT_APP_HP_API_URL}/users/registerConsumerCTA`,
      data: {
        uuid: localStorage.getItem('uuid'),
        ctaType: "cta1",
        ctaLabel: 'VitaCoco CTA button pressed'
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    await axios(options);
    // TODO: Update this URL to the correct RaceTrack destination
    window.location.href = 'https://vitacoco.com/pages/fueled-by-coconuts'
  }

  return (
    <IonPage>

      <IonContent className={`lay__container--${qrDetails?.eventQrId}`}>
        <div className="lay__background">
          <img src="https://pulseqr.b-cdn.net/qr16VitaCoco/Background2.png" />
          <div style={{position: 'absolute', bottom: 0, left: 0, width: '100%', zIndex: 3, lineHeight: 0}}>
              <img src="https://pulseqr.b-cdn.net/qr16VitaCoco/p5-bottom.png" style={{width: '100%', display: 'block'}} />
            </div>
        </div>

        {/* <div className="lay__background lay__background--border">
          <img src="https://pulseqr.b-cdn.net/qr16VitaCoco/Border.png" />
        </div> */}

        {typeof qrDetails != 'undefined' && 
          <div className={`lay__content--${qrDetails?.eventQrId}`}>

            <div className="img__first" style={{marginTop: '100px', marginBottom: '20px'}}>
              <div className="talent-signup__section-title talent-signup__section-title--smaller2">
                <img src="https://pulseqr.b-cdn.net/qr16VitaCoco/p5-img1.png" onClick={trackCTAClick} />
              </div>
            </div>

            

            {/* <div className="img__inline" style={{marginTop: '10px', zIndex: 3}}>
              <div className="">
                <img src="https://pulseqr.b-cdn.net/qr16VitaCoco/p4-img3.png" />
              </div>
            </div> */}

            {/* <div className="img__inline" style={{marginTop: '30px', zIndex: 3, width: '280px'}}>
              <div onClick={trackCTAClick} style={{cursor: 'pointer'}}>
                <img src="https://pulseqr.b-cdn.net/qr16VitaCoco/CTA-Submit2.png" />
              </div>
            </div> */}

          </div>}
          
      </IonContent>

    </IonPage>
  );
};

export default QR16VitaCocoSuccess;
